import { Routes, Route } from 'react-router-dom'
import { WalletProvider } from './providers/WalletProvider'
import { GameProvider } from './providers/GameProvider'
import { CRTEffect } from './components/retro/CRTEffect'
import { TitleScreen } from './screens/TitleScreen'
import { GameScreen } from './screens/GameScreen'
import { SettingsScreen } from './screens/SettingsScreen'
import { PrivacyScreen } from './screens/PrivacyScreen'
import { LicenseScreen } from './screens/LicenseScreen'
import { TermsScreen } from './screens/TermsScreen'

function App() {
  return (
    <WalletProvider>
      <GameProvider>
        <CRTEffect enabled={true}>
          <div className="min-h-screen bg-game-bg">
            <Routes>
              <Route path="/" element={<TitleScreen />} />
              <Route path="/game" element={<GameScreen />} />
              <Route path="/settings" element={<SettingsScreen />} />
              <Route path="/privacy" element={<PrivacyScreen />} />
              <Route path="/license" element={<LicenseScreen />} />
              <Route path="/terms" element={<TermsScreen />} />
              <Route path="/auth/twitter/callback" element={<TwitterCallback />} />
            </Routes>
          </div>
        </CRTEffect>
      </GameProvider>
    </WalletProvider>
  )
}

// Twitter OAuth callback handler
function TwitterCallback() {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="retro-window p-8">
        <p className="font-pixel text-pixel-base text-game-text">
          Processing Twitter login...
        </p>
      </div>
    </div>
  )
}

export default App
